import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
import { message } from 'antd';
import { startGetDetalle, startVoboAutorizacion, startSetPagado, startRechazarReembolso, startActualizarReembolso } from '../../../context/actions/reembolsosActions';

export const useDetalleReembolso = () => {
  const { reembolsoID } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadingRechazar, setLoadingRechazar] = useState(false);
  const [loadingActualizar, setLoadingActualizar] = useState(false);
  const [modalRechazarVisible, setModalRechazarVisible] = useState(false);
  const [modalActualizarVisible, setModalActualizarVisible] = useState(false);

  const fetchData = () => {
    dispatch(startGetDetalle(reembolsoID))
      .then(setData)
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchData();
  }, [reembolsoID]);

  const volver = () => history.push('/reembolsos');
  const reload = () => fetchData();

  const handleVobo = (tipoAutorizacion) => {
    dispatch(startVoboAutorizacion(Number(reembolsoID), tipoAutorizacion))
      .then(() => { message.success('Autorización registrada'); fetchData(); })
      .catch((e) => message.error(e.message));
  };

  const handlePagado = () => {
    dispatch(startSetPagado(Number(reembolsoID)))
      .then(() => { message.success('Reembolso marcado como pagado'); fetchData(); })
      .catch((e) => message.error(e.message));
  };

  const handleRechazar = (motivoRechazo, onSuccess) => {
    setLoadingRechazar(true);
    dispatch(startRechazarReembolso(Number(reembolsoID), motivoRechazo))
      .then((res) => {
        message.success(res?.message || 'Reembolso rechazado');
        onSuccess?.();
        fetchData();
      })
      .catch((e) => message.error(e.message))
      .finally(() => setLoadingRechazar(false));
  };

  const handleActualizar = (body, onSuccess) => {
    setLoadingActualizar(true);
    dispatch(startActualizarReembolso(Number(reembolsoID), body.monto, body.motivoReembolso, body.motivoAceptacion))
      .then((res) => {
        message.success(res?.message || 'Reembolso actualizado');
        onSuccess?.();
        fetchData();
      })
      .catch((e) => message.error(e.message))
      .finally(() => setLoadingActualizar(false));
  };

  const modalRechazarProps = {
    visible: modalRechazarVisible,
    onClose: () => setModalRechazarVisible(false),
    onConfirm: (motivo) => handleRechazar(motivo, () => setModalRechazarVisible(false)),
    loading: loadingRechazar,
  };

  const modalActualizarProps = {
    visible: modalActualizarVisible,
    onClose: () => setModalActualizarVisible(false),
    onConfirm: (body) => handleActualizar(body, () => setModalActualizarVisible(false)),
    loading: loadingActualizar,
  };

  return {
    data,
    loading,
    volver,
    reload,
    handleVobo,
    handlePagado,
    onRechazar: () => setModalRechazarVisible(true),
    onActualizar: () => setModalActualizarVisible(true),
    modalRechazarProps,
    modalActualizarProps,
  };
};